const COOKIE_KEYS = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER: "user",
};

function setCookie(name, value) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  // Persist for 6 months (matches refresh token lifetime)
  const maxAge = 180 * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Strict${secure}`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function removeCookie(name) {
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Strict`;
}

// --- public helpers ---

export function getAccessToken() {
  return getCookie(COOKIE_KEYS.ACCESS_TOKEN);
}

export function setAccessToken(token) {
  setCookie(COOKIE_KEYS.ACCESS_TOKEN, token);
}

export function getRefreshToken() {
  return getCookie(COOKIE_KEYS.REFRESH_TOKEN);
}

export function setRefreshToken(token) {
  setCookie(COOKIE_KEYS.REFRESH_TOKEN, token);
}

export function getStoredUser() {
  const raw = getCookie(COOKIE_KEYS.USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    removeCookie(COOKIE_KEYS.USER);
    return null;
  }
}

export function setStoredUser(user) {
  setCookie(COOKIE_KEYS.USER, JSON.stringify(user));
}

export function clearAuthCookies() {
  removeCookie(COOKIE_KEYS.ACCESS_TOKEN);
  removeCookie(COOKIE_KEYS.REFRESH_TOKEN);
  removeCookie(COOKIE_KEYS.USER);
}
